module.exports = __webpack_public_path__ + "img/s1_t1_16.9bcdb6c4.jpeg";